import { inject, observer } from 'mobx-react'
import compose from 'recompose/compose'

const injectStore = stores => ({
    isUserDraggingPano: stores.streams.panorama.isUserDraggingPano,
    isPanoAutoRotating: stores.streams.panorama.isPanoAutoRotating,
})

export default compose(
    inject(injectStore),
    observer
)
